{
  "version": "1.2.6",
  "objects": {
    "7452325891256635736": {
      "type": "frame",
      "id": "7452325891256635736",
      "z": 9224,
      "textContent": "",
      "left": 4174.458338077936,
      "top": -267.9606183456932,
      "width": 400,
      "height": 500,
      "scaleX": 0.9308261306107943,
      "scaleY": 0.37864072282773076,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7452325891254991490": {
      "type": "frame",
      "id": "7452325891254991490",
      "z": 7965,
      "textContent": "Frame 39",
      "left": 4194.458338077936,
      "top": -132.90304102273694,
      "width": 400,
      "height": 500,
      "scaleX": 0.8308261306107942,
      "scaleY": 0.06852556818181818,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7452325891256635736",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 2,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452325891245816802": {
      "type": "frame",
      "id": "7452325891245816802",
      "z": 7966,
      "textContent": "Frame 33",
      "left": 4196.458338077936,
      "top": -129.17773734722817,
      "width": 400,
      "height": 500,
      "scaleX": 0.15409796859268227,
      "scaleY": 0.055624353479783166,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7452325891254991490",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "Zz",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 2,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452325891244172656": {
      "type": "shape",
      "id": "7452325891244172656",
      "z": 7971,
      "shapeName": "circle",
      "textContent": "",
      "left": 4198.458338077936,
      "top": -120.28513826847278,
      "width": 100,
      "height": 100,
      "strokeType": 0,
      "strokeDouble": false,
      "scaleX": 0.1002697858238078,
      "scaleY": 0.1002697858238078,
      "stroke": "transparent",
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#3A5BCF",
      "angle": 0,
      "container": "7452325891245816802",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "locked": false
    },
    "7452325891249439381": {
      "type": "shape",
      "id": "7452325891249439381",
      "z": 7972,
      "shapeName": "circle",
      "textContent": "",
      "left": 4219.264442505282,
      "top": -120.28513826847278,
      "width": 100,
      "height": 100,
      "strokeType": 0,
      "strokeDouble": false,
      "scaleX": 0.1002697858238078,
      "scaleY": 0.1002697858238078,
      "stroke": "transparent",
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#CACACA",
      "angle": 0,
      "container": "7452325891245816802",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7452325891254893814": {
      "type": "shape",
      "id": "7452325891254893814",
      "z": 7973,
      "shapeName": "circle",
      "textContent": "",
      "left": 4240.0705469326285,
      "top": -120.28513826847278,
      "width": 100,
      "height": 100,
      "strokeType": 0,
      "strokeDouble": false,
      "scaleX": 0.1002697858238078,
      "scaleY": 0.1002697858238078,
      "stroke": "transparent",
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#CACACA",
      "angle": 0,
      "container": "7452325891245816802",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a2",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7452325891249776637": {
      "type": "wireframe",
      "id": "7452325891249776637",
      "z": 7970,
      "top": -130.40304102273694,
      "left": 4461.856973267505,
      "width": 82.57575607299805,
      "height": 40.35037878787879,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7452325891254991490",
      "layoutPosition": "a0",
      "wireframeName": "button",
      "fill": "#3A5BCF",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": {
        "state": "default",
        "value": "Next ",
        "iconLeft": null,
        "iconRight": { "prefix": "fas", "iconName": "arrow-right" }
      }
    },
    "7452325891257766317": {
      "type": "frame",
      "id": "7452325891257766317",
      "z": 7967,
      "textContent": "Frame 33",
      "left": 4194.458338077936,
      "top": -247.9606183456932,
      "width": 400,
      "height": 500,
      "scaleX": 0.8308261306107942,
      "scaleY": 0.076,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7452325891256635736",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "Zz",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452325891259142604": {
      "type": "shape",
      "id": "7452325891259142604",
      "z": 7968,
      "shapeName": "icon",
      "textContent": "",
      "left": 4511.661989307978,
      "top": -239.46205915711403,
      "width": 100,
      "height": 160,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.13126801014276016,
      "scaleY": 0.13126801014276016,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 0.5,
      "borderOpacity": 1,
      "fill": "#333333",
      "angle": 0,
      "container": "7452325891257766317",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "iconName": "fas/xmark",
      "locked": false,
      "reactions": {}
    },
    "7452325891244731451": {
      "type": "shape",
      "id": "7452325891244731451",
      "z": 7969,
      "shapeName": "text",
      "textContent": "<p><strong>Title</strong></p>",
      "left": 4194.458338077936,
      "top": -247.9606183456932,
      "width": 166.44444444444443,
      "height": 29.555555555555554,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.2857142857142858,
      "scaleY": 1.2857142857142858,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 0.5,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 18,
      "angle": 0,
      "container": "7452325891257766317",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7452347608711849513": {
      "type": "frame",
      "id": "7452347608711849513",
      "z": 9394,
      "textContent": "Frame 57",
      "left": 4194.458338077936,
      "top": -183.93182968421507,
      "width": 400,
      "height": 500,
      "scaleX": 0.8308261306107942,
      "scaleY": 0.05,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452325891256635736",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "ZzUt",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7452347608715394995": {
      "type": "shape",
      "id": "7452347608715394995",
      "z": 104,
      "shapeName": "text",
      "textContent": "<p>Description</p>",
      "left": 4194.458338077936,
      "top": -183.93182968421507,
      "width": 384.14103494730284,
      "height": 29.015542656896027,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8616071839710477,
      "scaleY": 0.8616071839710477,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.4,
      "textAlign": "left",
      "fontSize": 12.062500575594669,
      "angle": 0,
      "container": "7452347608711849513",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    }
  }
}
